/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
'use strict';

var Icon = require('../Icon-e1bb3d81.js');
var React = require('react');
require('@carbon/icon-helpers');
require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _circle, _circle2, _circle3;

var _excluded = ["children"];
var OverflowMenuHorizontal32 = /*#__PURE__*/React__default["default"].forwardRef(function OverflowMenuHorizontal32(_ref, ref) {
  var children = _ref.children,
      rest = Icon._objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Icon.Icon, Icon._extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _circle || (_circle = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
});

module.exports = OverflowMenuHorizontal32;
